<template>
  <v-navigation-drawer
    id="options-drawer"
    v-model="opened"
    right
    dark
    fixed
    mobile-break-point="991"
    color="primary"
    temporary
  >
    <AboutDialog ref="helpDialog"></AboutDialog>
    <RequestAppDialog ref="requestAppDialog"></RequestAppDialog>

    <v-toolbar color="primary" flat>
      <v-app-bar-nav-icon @click="onClick"></v-app-bar-nav-icon>

      <v-toolbar-title>Settings</v-toolbar-title>

      <v-spacer></v-spacer>
    </v-toolbar>

    <v-list subheader dense nav class="py-0">
      <v-subheader>Settings</v-subheader>

      <v-list-item link>
        <v-list-item-action>
          <v-checkbox v-model="autoopen"></v-checkbox>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>Autoopen output</v-list-item-title>
          <v-list-item-subtitle>Open output in a dialog</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list subheader dense nav class="py-0">
      <v-subheader>Information</v-subheader>

      <v-list-item link href="https://www.assistedcoding.eu/contact">
        <v-list-item-content>
          <v-list-item-title>Contact</v-list-item-title>
          <v-list-item-subtitle>Send us message!</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-icon>
          <v-icon>mdi-email</v-icon>
        </v-list-item-icon>
      </v-list-item>

      <v-list-item link>
        <v-list-item-content @click="displayRequestApp">
          <v-list-item-title>Want an app?</v-list-item-title>
          <v-list-item-subtitle>Request for an app</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-icon>
          <v-icon>wb_sunny</v-icon>
        </v-list-item-icon>
      </v-list-item>

      <v-list-item link>
        <v-list-item-content @click="displayHelp">
          <v-list-item-title>About</v-list-item-title>
          <v-list-item-subtitle>Learn about {{ $t('Common.title') }}</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-icon>
          <v-icon>mdi-help</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <!-- <v-list subheader dense nav class="py-0">
      <v-list-item link @click="displayHelp">
        <v-list-item-content>
          <v-list-item-title>Exit</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list> -->
  </v-navigation-drawer>
</template>

<script>
import AboutDialog from "@/components/dialog/AboutDialog";
import RequestAppDialog from "@/components/dialog/RequestAppDialog";

import { mapMutations } from "vuex";

export default {
  components: {
    AboutDialog,
    RequestAppDialog
  },
  computed: {
    opened: {
      get() {
        return this.$store.state.app.secondaryDrawer;
      },
      set(val) {
        this.setSecondaryDrawer(val);
      }
    },
    autoopen: {
      get() {
        return this.$store.state.app.autoopen;
      },
      set(val) {
        this.setAutoOpen(val);
      }
    }
  },
  methods: {
    ...mapMutations("app", ["setSecondaryDrawer", "setAutoOpen"]),
    onClick() {
      this.setSecondaryDrawer(!this.$store.state.app.secondaryDrawer);
    },
    displayHelp() {
      this.$refs.helpDialog.open().catch({});
    },
    displayRequestApp() {
      this.$refs.requestAppDialog.open().catch({});
    }
  }
};
</script>
